var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpClient } from '@angular/common/http';
import { BaseService } from "app/views/base.service";
import { DataProviderFactory } from "../provider/data2.provider";
var TemplateService = /** @class */ (function (_super) {
    __extends(TemplateService, _super);
    function TemplateService(http, dpf) {
        var _this = _super.call(this, http) || this;
        _this.http = http;
        _this.dpf = dpf;
        _this.tag = _this.dpf.getNew('template_tag');
        _this.siteSubCategories = _this.dpf.getNew('site_sub_categories');
        _this.template = _this.dpf.getNew('template');
        return _this;
    }
    return TemplateService;
}(BaseService));
export { TemplateService };
